<!-- Drawn on NavIcon's own 16-grid/1.7-stroke/butt-cap/miter-join hand: a box for a level, a calendar for a recurring payment, a percent glyph for a rate. -->
<script setup lang="ts">
defineProps<{ kind: 'outstanding' | 'monthly' | 'interest' }>()
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    class="block shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="butt"
    stroke-linejoin="miter"
  >
    <g v-if="kind === 'outstanding'">
      <path d="M8 2 13.5 5 13.5 11 8 14 2.5 11 2.5 5Z" />
      <path d="M8 2v6M8 8 13.5 5M8 8 2.5 5M8 8v6" />
    </g>
    <g v-else-if="kind === 'monthly'">
      <rect x="2.5" y="3.5" width="11" height="10" rx="1" />
      <path d="M2.5 6.5h11" />
      <path d="M5.5 2v3M10.5 2v3" />
    </g>
    <g v-else>
      <path d="M12.6 3.4 3.4 12.6" />
      <circle cx="4.6" cy="4.6" r="1.8" />
      <circle cx="11.4" cy="11.4" r="1.8" />
    </g>
  </svg>
</template>
